import {
  TrainingCategoryBackendModel,
  TrainingCategoryModel,
} from './training-category.model';

export type NewsBannerModel = {
  id: number;
  title: string;
  subtitle?: string;
  description: string;
  teaserText: string;
  contentType: NewsBannerContentType;
  image?: File;
  category?: TrainingCategoryModel;
  position: number;
  link?: string;
  linkText?: string;
};

export type NewsBannerSlideModel = {
  newsBannerId?: number;
  imageUrl?: string;
  title: string;
  subtitle?: string;
  description: string;
  teaserText: string;
  color0?: string;
  color50?: string;
  color70?: string;
  color80?: string;
  color90?: string;
  link?: string;
  linkText?: string;
};

export type NewsBannerBackendModel = {
  id: number;
  title: string;
  sub_title?: string;
  description: string;
  teaser_text: string;
  content_type: NewsBannerContentType;
  image?: string;
  position: number;
  category?: TrainingCategoryBackendModel;
  link?: string;
  link_text?: string;
};

export type NewsBannerCreateModel = {
  title: string;
  subtitle?: string;
  description: string;
  teaserText: string;
  contentType: NewsBannerContentType;
  image?: File;
  categoryId?: number;
  link?: string;
  linkText?: string;
};

export type NewsBannerUpdateModel = {
  id: number;
  title: string;
  subtitle?: string;
  description: string;
  teaserText: string;
  contentType: NewsBannerContentType;
  image?: File;
  categoryId?: number;
  link?: string;
  linkText?: string;
};

export type NewsBannerOrderModel = {
  id: number;
  position: number;
};

export enum NewsBannerContentType {
  Image = 'image',
  Default = 'default',
  Category = 'category',
}
